export const jobManuallyAddLocationInitialState = {
  manuallyAddLocationDialogVisible: false as boolean,
  manuallyAddLocationDialog: {
    locationType: '' as string,
    streetNumber: '' as string,
    streetName: '' as string,
    areaCode: '' as string,
    country: '' as string,
    city: undefined as string | undefined,
    jurisdiction: undefined as string | undefined,
    showAddressNotRecognizedWarning: false as boolean,
  }
} as const;
